import React, { Component } from "react";
import { observer } from "mobx-react";
import moment from 'moment';
import { fn_bridge_incomplete_menu } from "function/FnPosBridge";
import { fn_scroll_up_select, fn_scroll_down_select } from "function/FnScroll"
import { fn_setReturnListInit, fn_return_auto_refund, fn_return_fail_click } from "function/FnBodySetting"

@observer
class IncompleteMenu extends Component {
    constructor(props) {
        super(props);
        this.inputFocus = React.createRef();
    }

    scrollUp = () => {
        const { rootStore } = this;
        fn_scroll_up_select(this.inputFocus, rootStore);
    }

    scrollDown = () => {
        const { rootStore } = this;
        fn_scroll_down_select(this.inputFocus, rootStore);
    }

    list = (menuList) => {
        const { rootStore } = this.props;
        let list = []
        for (let i = 0; i < menuList.length; i++) {
            for(let j = 0; j < menuList[i].viewProds.length; j++){
                list.push(menuList[i].viewProds[j])
            }
        }

        // 새로운 배열을 만들기 위한 빈 객체 생성
        let result = {};
        let cnt = 0
        // 기존 배열 순회하면서 prodCode를 키로 saleQty를 더합니다.
        list.forEach(function(item) {
            let prodCode = item.prodCode;
            if(item.prodType == "M"){
                cnt += parseInt(item.saleQty)
                if (result[prodCode]) {
                    // 이미 해당 prodCode가 존재하는 경우 saleQty를 더합니다.
                    result[prodCode].saleQty += parseInt(item.saleQty);
                } else {
                    // 해당 prodCode가 처음 발견된 경우 객체에 추가합니다.
                    result[prodCode] = {
                        prodCode: prodCode,
                        prodName: item.prodName,
                        saleQty: parseInt(item.saleQty)
                    };
                }
            }
        });

        
        // 객체를 배열로 변환합니다.
        let newArray = Object.values(result);
        return (
            <>
            <div className="info">
                <h2>처리중 주문 : {rootStore.menuStore.getIncompleteMenuCnt}건</h2>
                <h2 className="not">미완료 메뉴 : {cnt}개</h2>
            </div>
            <div className="new">
                <p className="txt">먼저 들어온 주문 30건의 미완료 메뉴만 집계됩니다 <br/> 처리중 주문이 상태가 변경된 경우,새로고침 해주세요</p>
            </div>
            <div className="box">       
                <div className="totalCnt"><span>({rootStore.viewStore.getIncompleteMenuNewTime} 기준)</span></div>
                <button className="refresh">
                    <span className="txt" onClick={event => { fn_bridge_incomplete_menu(rootStore) }}>새로고침</span>
                </button>
            </div>
            <div className="wrap_incomplete_list">
                <div className="scroll scroll_hidden" ref={this.inputFocus}>
                    <ul className="list">
                        {
                            newArray.map((item, index) => (
                                <li key={index} className="menuList">
                                    <span className="menu">{item.prodName}</span>
                                    <span className="cnt">{item.saleQty}</span>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            </div>
            </>
        )
    }

    render() {
        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        const menuList = rootStore.menuStore.getIncompleteMenuList

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getIncompleteMenu ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content">
                    <div className="wrap incomplete">
                        <div className="section_tit_comm pd">
                            <h1>미완료 메뉴별 수량 <span className="sub">(키오스크, 포스 선불, 테이블/QR오더)</span></h1>
                        </div>
                        <div className="section incomplete">
                            {this.list(menuList)}
                        </div>
                        <div className="btns">
                            <button type="button" className="btn_up" onClick={this.scrollUp}><span></span></button>
                            <button type="button" className="btn_down" onClick={this.scrollDown}><span></span></button>
                        </div>
                        <div className="btn_close btn_close_comm">
                            <button onClick={event => { rootStore.layerStore.setIncompleteMenu(false) }}>
                                <span className="incomplete">닫기</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default IncompleteMenu;